// Shared country code list — ordered by prevalence in Saudi Arabia.
// GCC + Arab world first, then South/Southeast Asia (large expat groups),
// then Africa, then Western countries commonly represented.
export const COUNTRY_CODES = [
  // GCC
  { code: '+966', country: 'SA', flag: '🇸🇦', name_ar: 'السعودية',          name_en: 'Saudi Arabia' },
  { code: '+971', country: 'AE', flag: '🇦🇪', name_ar: 'الإمارات',           name_en: 'UAE' },
  { code: '+965', country: 'KW', flag: '🇰🇼', name_ar: 'الكويت',             name_en: 'Kuwait' },
  { code: '+974', country: 'QA', flag: '🇶🇦', name_ar: 'قطر',               name_en: 'Qatar' },
  { code: '+973', country: 'BH', flag: '🇧🇭', name_ar: 'البحرين',            name_en: 'Bahrain' },
  { code: '+968', country: 'OM', flag: '🇴🇲', name_ar: 'عُمان',              name_en: 'Oman' },

  // Arab world
  { code: '+967', country: 'YE', flag: '🇾🇪', name_ar: 'اليمن',              name_en: 'Yemen' },
  { code: '+963', country: 'SY', flag: '🇸🇾', name_ar: 'سوريا',              name_en: 'Syria' },
  { code: '+961', country: 'LB', flag: '🇱🇧', name_ar: 'لبنان',              name_en: 'Lebanon' },
  { code: '+962', country: 'JO', flag: '🇯🇴', name_ar: 'الأردن',             name_en: 'Jordan' },
  { code: '+970', country: 'PS', flag: '🇵🇸', name_ar: 'فلسطين',             name_en: 'Palestine' },
  { code: '+964', country: 'IQ', flag: '🇮🇶', name_ar: 'العراق',             name_en: 'Iraq' },
  { code: '+20',  country: 'EG', flag: '🇪🇬', name_ar: 'مصر',               name_en: 'Egypt' },
  { code: '+249', country: 'SD', flag: '🇸🇩', name_ar: 'السودان',            name_en: 'Sudan' },
  { code: '+218', country: 'LY', flag: '🇱🇾', name_ar: 'ليبيا',              name_en: 'Libya' },
  { code: '+216', country: 'TN', flag: '🇹🇳', name_ar: 'تونس',              name_en: 'Tunisia' },
  { code: '+213', country: 'DZ', flag: '🇩🇿', name_ar: 'الجزائر',            name_en: 'Algeria' },
  { code: '+212', country: 'MA', flag: '🇲🇦', name_ar: 'المغرب',             name_en: 'Morocco' },
  { code: '+252', country: 'SO', flag: '🇸🇴', name_ar: 'الصومال',            name_en: 'Somalia' },
  { code: '+291', country: 'ER', flag: '🇪🇷', name_ar: 'إريتريا',            name_en: 'Eritrea' },

  // South Asia (large expat communities in KSA)
  { code: '+92',  country: 'PK', flag: '🇵🇰', name_ar: 'باكستان',            name_en: 'Pakistan' },
  { code: '+91',  country: 'IN', flag: '🇮🇳', name_ar: 'الهند',              name_en: 'India' },
  { code: '+880', country: 'BD', flag: '🇧🇩', name_ar: 'بنغلاديش',           name_en: 'Bangladesh' },
  { code: '+94',  country: 'LK', flag: '🇱🇰', name_ar: 'سريلانكا',           name_en: 'Sri Lanka' },
  { code: '+977', country: 'NP', flag: '🇳🇵', name_ar: 'نيبال',              name_en: 'Nepal' },

  // Southeast Asia
  { code: '+63',  country: 'PH', flag: '🇵🇭', name_ar: 'الفلبين',            name_en: 'Philippines' },
  { code: '+62',  country: 'ID', flag: '🇮🇩', name_ar: 'إندونيسيا',          name_en: 'Indonesia' },

  // East Africa
  { code: '+254', country: 'KE', flag: '🇰🇪', name_ar: 'كينيا',              name_en: 'Kenya' },
  { code: '+251', country: 'ET', flag: '🇪🇹', name_ar: 'إثيوبيا',            name_en: 'Ethiopia' },
  { code: '+256', country: 'UG', flag: '🇺🇬', name_ar: 'أوغندا',             name_en: 'Uganda' },

  // Turkey / Iran / Central Asia
  { code: '+90',  country: 'TR', flag: '🇹🇷', name_ar: 'تركيا',              name_en: 'Turkey' },
  { code: '+98',  country: 'IR', flag: '🇮🇷', name_ar: 'إيران',              name_en: 'Iran' },

  // Western / other
  { code: '+1',   country: 'US', flag: '🇺🇸', name_ar: 'الولايات المتحدة',   name_en: 'United States' },
  { code: '+44',  country: 'GB', flag: '🇬🇧', name_ar: 'المملكة المتحدة',    name_en: 'United Kingdom' },
  { code: '+33',  country: 'FR', flag: '🇫🇷', name_ar: 'فرنسا',              name_en: 'France' },
  { code: '+49',  country: 'DE', flag: '🇩🇪', name_ar: 'ألمانيا',            name_en: 'Germany' },
  { code: '+7',   country: 'RU', flag: '🇷🇺', name_ar: 'روسيا',              name_en: 'Russia' },
  { code: '+86',  country: 'CN', flag: '🇨🇳', name_ar: 'الصين',              name_en: 'China' },
  { code: '+82',  country: 'KR', flag: '🇰🇷', name_ar: 'كوريا الجنوبية',    name_en: 'South Korea' },
  { code: '+81',  country: 'JP', flag: '🇯🇵', name_ar: 'اليابان',            name_en: 'Japan' },
];

/**
 * Split a stored full number (e.g. "966501234567") into { code: '+966', local: '501234567' }.
 * Falls back to +966 if no matching prefix is found.
 */
export const splitPhoneAndCode = (fullNumber) => {
  const digits = String(fullNumber || '').replace(/\D/g, '');
  // Sort longest code first to avoid +1 matching before +1x codes
  const sorted = [...COUNTRY_CODES].sort(
    (a, b) => b.code.replace(/\D/g, '').length - a.code.replace(/\D/g, '').length
  );
  for (const c of sorted) {
    const cDigits = c.code.replace(/\D/g, '');
    if (digits.startsWith(cDigits)) {
      return { code: c.code, local: digits.slice(cDigits.length) };
    }
  }
  return { code: '+966', local: digits };
};
